/**
 * Feedback form — "Share your experience" (Contact Us, TZ section 4).
 * After a successful send `_utils.wpcf7()` adds `.thanks` to the `.cf7` wrapper (Thank you replaces the form);
 * "Write new" ([data-cf7-reset]) brings back the initial form: empty fields, no errors, CF7 status "init".
 */
export const feedbackForm = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('[data-cf7-reset]').forEach((button) => {
            const wrapper = button.closest('.cf7');
            const form = wrapper && wrapper.querySelector('form.wpcf7-form');
            if (!form) return;

            button.addEventListener('click', () => {
                form.reset();
                form.querySelectorAll('.wpcf7-not-valid-tip').forEach((tip) => tip.remove());
                form.querySelectorAll('.wpcf7-not-valid').forEach((field) => {
                    field.classList.remove('wpcf7-not-valid');
                    field.removeAttribute('aria-invalid');
                });
                form.classList.remove('sent', 'invalid', 'failed', 'spam', 'unaccepted', 'payment-required');
                form.classList.add('init');
                form.setAttribute('data-status', 'init');
                form.style.pointerEvents = '';

                const output = form.querySelector('.wpcf7-response-output');
                if (output) output.textContent = '';

                wrapper.classList.remove('thanks');
                const firstField = form.querySelector('input:not([type="hidden"]), textarea');
                if (firstField) firstField.focus({preventScroll: true});
            });
        });
        resolve();
    });
};
